const initialState: Array<any> = [];

/**
 * managePartDataListReducer: Reducer to handle actions related to the part data list.
 *
 * @param {any} state - The current state of the part data list.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */
const managePartDataListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_PART_DATA_LIST_DATA":
      return action?.payload;
    case "MERGE_PART_DATA_LIST_DATA": {
      // action.payload is the new batch of images
      const newBatch = action.payload || [];
      const limit = action.limit || 20;

      // Merge and remove duplicates by _id
      const combined = [...newBatch, ...state];
      const deduplicated = combined.filter((v, i, a) =>
        a.findIndex(t => t?._id === v?._id) === i
      );

      // Respect the pagination limit for the first page
      return deduplicated.slice(0, limit);
    }
    default:
      return state;
  }
};

export default managePartDataListReducer;
